
import Types from "./types";
import { CarService } from "../../../service/car-service";
import { LeadServiceJava } from "../../../service/lead-service-java-api";
import { AB_TEST_VARIATIONS, HTTP_CODES } from "../../../constants/app-constants";
import parseVehicleNumberDetails from "../../../utils/parsers/parse-vehicle-number-details";
import parseRegNoResponse from "../../../utils/parsers/parse-reg-no-response";

const setUserCarRegistrationNO = number => ({
    type: Types.SET_USER_CAR_REGISTRATION_NO,
    number
});

const setDataFaliure = (flag) => ({
    type: Types.SET_ERROR,
    flag
});

const fetchDataSuccess = data => ({
    type: Types.FETCH_REGISTRATION_NO_DETAIL,
    data
});

const setIsChangingPreFetchedDetail = flag => ({
    type: Types.IS_CHANGING_PRE_FETCHED_DETAIL,
    flag
});

const resetRegistrationData = () => ({
    type: Types.RESET_REGISTRATION_DATA
});

const setAllDetailFetchedCorrectly = flag => ({
    type: Types.ALL_DETAIL_FETCHED_CORRECTLY,
    flag
});

const setDuplicateInspectionInfo = duplicateInspectionInfo => ({
    type: Types.SET_DUPLICATE_INSPECTION_INFO,
    duplicateInspectionInfo
});

const setIsRepeatInspection = isRepeatInspection => ({
    type: Types.SET_IS_REPEAT_INSPECTION,
    isRepeatInspection
});

const getVehicleDetail = (registrationNo, extraParams) => dispatch => {
    dispatch(resetRegistrationData());
    dispatch(setUserCarRegistrationNO(registrationNo));
    return new Promise((resolve, reject) => {
        CarService.vehicleNoRegistrationV1(registrationNo, extraParams)
            .then(response => {
                const details  = parseRegNoResponse(response.data.detail);
                dispatch(fetchDataSuccess(details));
                resolve(details);
            })
            .catch(error => {
                dispatch(setDataFaliure(true));
                reject(error);
            });
    });
};

const checkForDuplicateAppointment = (regNumber, leadsource, secureToken) => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.checkInspectedAppointmentExistence(regNumber, leadsource, true, secureToken)
            .then((response) => {
                const data = parseVehicleNumberDetails(response.data.detail);
                dispatch(setDuplicateInspectionInfo(data));
                resolve({
                    ...data,
                    isRepeatInspection: response.data.detail.userJourneyAbExperiment !== AB_TEST_VARIATIONS.CONTROL
                });
            })
            .catch(error => {
                const { status  } = error;
                if (status === HTTP_CODES.NOT_FOUND) {
                    resolve({
                        isRepeatInspection: false
                    });
                } else {
                    reject(error);
                }
            });
    });
};

const getRepeatInspectionDetails = (data) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getRepeatInspectionDetails(data, true)
            .then((response) => {
                resolve(response.data.detail);
            }).catch((error) => {
                reject(error);
            });
    });
};

export {
    getVehicleDetail,
    setDataFaliure,
    resetRegistrationData,
    setUserCarRegistrationNO,
    setAllDetailFetchedCorrectly,
    setIsChangingPreFetchedDetail,
    checkForDuplicateAppointment,
    getRepeatInspectionDetails,
    setIsRepeatInspection
};
